import * as Sentry from '@sentry/react';
import { CaptureContext } from '@sentry/types';

const captureAndReturnReadable = (error: Error | Response, captureContext?: CaptureContext) => {
    Sentry.captureException(error, captureContext);

    if (error instanceof Error) {
        return error.name ? `${error.name}\n${error.message}` : error.message;
    } else {
        return error.statusText || 'Unknown error' + error.url ? ` at ${error.url}` : '';
    }
};

export const logError = (message: string, error?: unknown, ...rest: unknown[]) => {
    console.error(message, error, ...rest, 'xxx');
};

export const logApiError = (error: unknown) => {
    logError('ApiError', error);
};

export const captureException = async (exception: Error | Response, extra?: unknown, actionName?: string) => {
    if (exception instanceof Response) {
        const responseClone = exception.clone();
        const responseBody = exception.clone();

        const payload = await responseBody.json();

        responseClone.text().then((text: string) => {
            const responseError = new Error(text);
            responseError.name = ((response: Response) => {
                switch (response.status) {
                    case 429:
                        return '429 Too Many Requests';
                    case 502:
                        return '502 Bad Gateway';
                    case 504:
                        return '504 Gateway Timeout';
                    case 524:
                        return '524 A Timeout Occurred';
                    default:
                        return `${response.status} ${response.url.replace(/\d+/g, '[filtered]')}`;
                }
            })(exception);

            const readableError = captureAndReturnReadable(responseError, {
                extra: {
                    variables: extra,
                    payload,
                    actionName,
                },
            });

            logError('API Error', readableError);
        });
    } else {
        logError('Error', captureAndReturnReadable(exception, { extra: { variables: extra } }));
    }

    throw exception;
};
